import { ReactNode } from 'react'

import { ErrorMap } from '..'

import mapBg from 'shared/images/map-bg.png'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

interface LayoutMapProps {
  map?: ReactNode
  title?: string
  zoomControls?: ReactNode
  isMapLoading?: boolean
  mapError?: string | null
  handleRetry?: () => void
}

export const LayoutMap = ({
  map,
  mapError,
  title,
  zoomControls,
  isMapLoading,
  handleRetry,
}: LayoutMapProps) => {
  return (
    <section className={s.container}>
      <div className={s.header}>
        <HeaderGoBack
          buttonWhite
          variant="grey"
          title={title || ''}
        />
      </div>

      <div className={s.mapContainer}>
        {map}

        {isMapLoading && (
          <div className={s.loadingOverlay}>
            <ImageLazy
              src={mapBg}
              className={s.mapBg}
            />
            <Loader />
          </div>
        )}

        {mapError && (
          <ErrorMap
            error={mapError}
            onTryAgain={handleRetry}
          />
        )}
      </div>

      {zoomControls}
    </section>
  )
}
